import { jsx as _jsx } from "react/jsx-runtime";
import { UploadContext } from "@air/component-upload-dropzone";
import { ContentCollectionOnboardingCard } from "@air/feature-content-collection/ui";
import { useContext } from "react";
import { useSelector } from "react-redux";
import { boardCollectionFormSelector } from "~/store/boardCollection/selectors";
export const BoardCollectionOnboardingView = ()=>{
    const form = useSelector(boardCollectionFormSelector);
    const { openUploader } = useContext(UploadContext);
    return /*#__PURE__*/ _jsx("div", {
        className: "flex h-full grow items-center justify-center bg-grey-3 py-8",
        children: /*#__PURE__*/ _jsx(ContentCollectionOnboardingCard, {
            description: form === null || form === void 0 ? void 0 : form.description,
            onUpload: openUploader,
            title: (form === null || form === void 0 ? void 0 : form.title) || ""
        })
    });
};
